'use client';

import React from 'react';
import { NavItem } from 'mmds';
import useCollection from '@app/[lang]/collections/state';
import notNull from '@app/lib/helpers/not-null';
import { FilterValue } from '@app/[lang]/collections/collection-filtering-toolbar/types';
import s from '@app/[lang]/collections/collection-filtering-wayfinder/collection-filtering-wayfinder.module.css';
import startCase from 'lodash.startcase'

const FeaturedFilters = ({ featuredFilters }) => {
    const { availableFilters, selectedFilters, setSelectedFilters } =
        useCollection();

    const getFilterIDFromValueID = (valueID: string) => {
        return valueID.substring(0, valueID.lastIndexOf('.'));
    };

    const selectedFilterValueIndex = (filterValue: FilterValue) => {
        return selectedFilters.findIndex(
            (selectedFilter) =>  {
                const filterValueId = startCase(filterValue.id.split(".").pop())
                const selectedFilterId = startCase(selectedFilter.id.split(".").pop())
                return selectedFilterId === filterValueId
            }
        );
    };

    const filterOptions = availableFilters
        .sort(
            (a, b) =>
                featuredFilters.indexOf(a.id) - featuredFilters.indexOf(b.id)
        )
        .filter((filter) => featuredFilters.includes(filter.id))
        .flatMap((filter) => {
            const values = filter.values.filter((value) => value.count > 0);

            if (values.length > 1) return values;

            const selectedValues = selectedFilters.filter(
                (selectedFilterValue) =>
                    getFilterIDFromValueID(selectedFilterValue.id) === filter.id
            );

            return selectedValues;
        })
        .filter(notNull)
        .filter((filterOption) => {
            // This filters out any filter options remaining for a filter type which already has a selection
            const existingSelection = selectedFilters.find((selectedFilter) => {
                const id = getFilterIDFromValueID(selectedFilter.id);
                return filterOption.id.indexOf(id) > -1;
            });

            if (existingSelection) {
                return filterOption.label === existingSelection.label;
            }

            return true;
        })
        .sort((a, b) => {
            if (
                selectedFilterValueIndex(a) === -1 &&
                selectedFilterValueIndex(b) > -1
            ) {
                return 1;
            }

            if (
                selectedFilterValueIndex(b) === -1 &&
                selectedFilterValueIndex(a) > -1
            ) {
                return -1;
            }

            return (
                selectedFilters.findIndex((selected) => selected.id === a.id) -
                selectedFilters.findIndex((selected) => selected.id === b.id)
            );
        });

    return (
        <div className={s.root}>
            {filterOptions.map((filter) => {
                const isSelected = selectedFilters.some(
                    (selectedFilter) => {
                        const filterId = startCase(filter.id.split(".").pop())
                        const selectedFilterId = startCase(selectedFilter.id.split(".").pop())
                        return selectedFilterId === filterId
                    }
                );
                return (
                    <div key={filter.id}>
                        <NavItem
                            key={filter.label}
                            label={`${filter.label}`}
                            count={filter.count}
                            className={s.wayfinderItem}
                            active={isSelected}
                            onSelect={() => {
                                if (isSelected) {
                                    setSelectedFilters(
                                        selectedFilters.filter(
                                            (selectedFilter) => {
                                                const filterId = startCase(filter.id.split(".").pop())
                                                const selectedFilterId = startCase(selectedFilter.id.split(".").pop())
                                                return selectedFilterId !== filterId
                                            }
                                        )
                                    );
                                } else {
                                    setSelectedFilters([
                                        ...selectedFilters,
                                        filter,
                                    ]);
                                }
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default FeaturedFilters;
